/* eslint-disable react-hooks/exhaustive-deps */
import { C } from "@fullcalendar/core/internal-common";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { ProgressSpinner } from "primereact/progressspinner";
import { Toast } from "primereact/toast";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getFormByFormID } from "./fetchData";
import { Image } from "primereact/image";
import { Dialog } from "primereact/dialog";
import ViewEquipmentform from "../Equipment Checklist form/ViewEquipmentForm";
import ViewConfinedSpacesEquipment from "../Confined Spaces Equipment form/ViewConfinedSpacesEquipment";
import ViewPermitSpaceEntryForm from "../Permit Confined Space Entry Form/ViewPermitSpaceEntryForm";

const ViewEnvironmentalSurveying = () => {
  const query = new URLSearchParams(window.location.search);
  const formIDParam = Number(query.get("formID"));
  const ImageNotAvailable = process.env.REACT_APP_IMAGE_NOT_FOUND_URL || "";

  const [showEquipmentFormPopup, setShowEquipmentFormPopup] = useState(false);
  const [showConfinedSpaceFormPopup, setShowConfinedSpaceFormPopup] =
    useState(false);
  const [showPermitSpaceFormPopup, setShowPermitSpaceFormPopup] =
    useState(false);
  const icon = (
    <i
      className="pi pi-eye tw-text-white tw-h-full tw-w-full tw-justify-center tw-items-center tw-flex"
      style={{
        backgroundColor: "black",
        opacity: 0.5,
        transition: "opacity 0.3s ease",
      }}
    ></i>
  );
  const toast = useRef<Toast>(null);
  const [formData, setFormData] = useState<any>(null);
  const [formDataLoading, setFormDataLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!formIDParam) {
      navigate("/layout/health-and-safety/permit-for-confined-space-entry");
    }
    getFormByFormID(
      setFormData,
      setFormDataLoading,
      formIDParam,
      navigate,
      toast
    );
  }, []);

  if (!formData) {
    return (
      <div className="tw-h-full tw-w-full tw-bg-transparent tw-flex tw-justify-center tw-items-center tw-absolute tw-top-0 tw-left-[50px] lg:tw-left-[120px] tw-z-50">
        <ProgressSpinner />
      </div>
    );
  }

  const { formJson, fileJson, timeStampLocationJson } = formData;

  // Get signature URL by userID
  const getSignatureUrl = (userId: number) => {
    const signature = fileJson?.envSignatures?.find((s: any) =>
      s.originalname.includes(`${userId}_sig`)
    );
    return signature?.file || ImageNotAvailable;
  };

  // Get photo URL by userID
  const getPhotoUrl = (userId: number) => {
    const photo = fileJson?.teamPhotos?.find((p: any) =>
      p.originalname.includes(`${userId}_photo`)
    );
    return photo?.file || ImageNotAvailable;
  };

  // Helper to get equipment photo by label
  const getVanPhoto = (photoNumber: number) => {
    const photo =
      fileJson?.vanPhotos &&
      fileJson?.vanPhotos?.find((img: any) =>
        img.originalname.toLowerCase().includes(`van_photo-${photoNumber}`)
      );
    return photo?.file || ImageNotAvailable;
  };

  // Helper to get timestamp and location by photoKey
  const getPhotoMeta = (photoKey: string) => {
    const locationObj = timeStampLocationJson?.locations?.find(
      (loc: any) => loc.photoKey === photoKey
    );
    const timeObj = timeStampLocationJson?.timeStamps?.find(
      (t: any) => t.photoKey === photoKey
    );
    return {
      address: locationObj?.address || "",
      timestamp: timeObj?.timestamp || "",
    };
  };

  // Get signatures by type and maintain order
  const getSignaturesByType = (type: "approval" | "closure") => {
    const sigs = fileJson.signatures.filter((sig: any) =>
      sig.originalname.includes(`_sig_${type}`)
    );

    // Sort signatures to match the order of names in formJson.name
    return sigs.sort((a: any, b: any) => {
      const aId = a.originalname.split("_")[0];
      const bId = b.originalname.split("_")[0];
      const aIndex = formJson.name.findIndex(
        (n: any) => n.userID.toString() === aId
      );
      const bIndex = formJson.name.findIndex(
        (n: any) => n.userID.toString() === bId
      );
      return aIndex - bIndex;
    });
  };

  // Get user role for display
  const getEntrantTopman = (user: any, type: string) => {
    return (
      formJson?.entrantTopmans[type].find(
        (u: any) => u.userID.toString() === user.userID.toString()
      )?.value || "N/A"
    );
    // return "Other Personnel";
  };

  // const approvalSignatures = getSignaturesByType("approval");
  // const closureSignatures = getSignaturesByType("closure");

  // Format date and time from timestamp
  const formatDate = (timestamp: number) => {
    if (!timestamp) return "N/A";
    const date = new Date(timestamp * 1000);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  return (
    <React.Fragment>
      <div className="tw-border-solid tw-border tw-border-[#E2E2e2] tw-rounded-lg tw-relative tw-bg-white">
        <div className="tw-bg-[#F8FAFC] tw-p-4 tw-rounded-t-lg tw-border-b-[1px] tw-border-[#E2E8F0] tw-flex tw-justify-between tw-items-center">
          <h2 className="tw-text-2xl tw-font-semibold tw-text-[#101828]">
            View Environmental Surveying
          </h2>
        </div>
        <div>
          <div className="tw-pt-4 tw-pb-2 tw-border-b-[1px] tw-border-[#E2E8F0] tw-px-4 ">
            <h2 className="tw-text-xl tw-font-semibold tw-text-[#101828]">
              Part 1: Basic Details
            </h2>
          </div>
          <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 2xl:tw-grid-cols-4 tw-gap-6 tw-px-4 tw-py-4">
            <div className="tw-flex tw-flex-col tw-items-start tw-gap-1">
              <p className="leak-detail-label">Project Name & Project No. </p>
              <p className="leak-value">{formJson.projectKeyName || "N/A"}</p>
            </div>
            <div className="tw-flex tw-flex-col tw-items-start tw-gap-1">
              <p className="leak-detail-label">Date </p>
              <p className="leak-value">
                {formatDate(formJson?.date) || "N/A"}
              </p>
            </div>
            <div className="tw-flex tw-flex-col tw-items-start tw-gap-1">
              <p className="leak-detail-label">Location </p>
              <p className="leak-value">{formJson?.location || "N/A"}</p>
            </div>
            <div className="tw-flex tw-flex-col tw-items-start tw-gap-1">
              <p className="leak-detail-label">Vehicle Registration</p>
              <p className="leak-value">
                {formJson?.vehicleRegistration || "N/A"}
              </p>
            </div>
          </div>
          <div className="tw-grid tw-grid-cols-3  lg:tw-gap-10 tw-gap-4 tw-items-center tw-justify-start tw-p-4 tw-flex-wrap">
            {/* Team Member 1 */}
            <div className="tw-flex tw-items-start tw-justify-start tw-gap-2 tw-flex-col">
              <div className="tw-flex tw-items-center tw-gap-1 tw-flex-wrap">
                <p className="leak-detail-label">Team Member 1 :</p>
                <p className="leak-value">
                  {formJson?.teamMember1?.displayName}
                </p>
              </div>
              <p className="leak-detail-label">Photo of Team Member 1</p>
              <div className="tw-flex tw-gap-2 tw-items-start tw-justify-start tw-flex-wrap">
                <Image
                  src={getPhotoUrl(formJson?.teamMember1?.userID)}
                  alt="team member"
                  className="tw-w-32 tw-shrink-0 tw-object-contain"
                  indicatorIcon={icon}
                  preview
                  loading="lazy"
                  pt={{
                    rotateRightButton: { className: "tw-text-white" },
                    downloadButton: { className: "tw-text-white" },
                    rotateLeftButton: { className: "tw-text-white" },
                    zoomInButton: { className: "tw-text-white" },
                    zoomOutButton: { className: "tw-text-white" },
                    closeButton: { className: "tw-text-white" },
                  }}
                  onError={(e) => {
                    (e.target as HTMLImageElement).src =
                      "path/to/default/image.png";
                  }}
                />
              </div>
              {/* Timestamp and Address */}
              {timeStampLocationJson && (
                <>
                  {timeStampLocationJson?.locations?.map((location: any) => {
                    if (location.userID === formJson?.teamMember1?.userID) {
                      const timestamp = timeStampLocationJson?.timeStamps?.find(
                        (time: any) => time.userID === location.userID
                      );
                      return (
                        <div key={location.userID} className="tw-mt-2">
                          <p className="tw-text-sm tw-text-gray-600">
                            <span className="tw-font-semibold">Location:</span>{" "}
                            {location.address}
                          </p>
                          <p className="tw-text-sm tw-text-gray-600">
                            <span className="tw-font-semibold">Timestamp:</span>{" "}
                            {timestamp?.timestamp}
                          </p>
                        </div>
                      );
                    }
                    return null;
                  })}
                </>
              )}
            </div>

            {/* Team Member 2 */}
            {formJson?.teamMember2?.userID && (
              <div className="tw-flex tw-items-start tw-justify-start tw-gap-2 tw-flex-col">
                <div className="tw-flex tw-items-center tw-gap-1 tw-flex-wrap">
                  <p className="leak-detail-label">Team Member 2 :</p>
                  <p className="leak-value">
                    {formJson?.teamMember2?.displayName}
                  </p>
                </div>
                <p className="leak-detail-label">Photo of Team Member 2</p>
                <div className="tw-flex tw-gap-2 tw-items-start tw-justify-start tw-flex-wrap">
                  <Image
                    src={getPhotoUrl(formJson?.teamMember2?.userID)}
                    alt="team member"
                    className="tw-w-32 tw-shrink-0 tw-object-contain"
                    indicatorIcon={icon}
                    preview
                    loading="lazy"
                    pt={{
                      rotateRightButton: { className: "tw-text-white" },
                      downloadButton: { className: "tw-text-white" },
                      rotateLeftButton: { className: "tw-text-white" },
                      zoomInButton: { className: "tw-text-white" },
                      zoomOutButton: { className: "tw-text-white" },
                      closeButton: { className: "tw-text-white" },
                    }}
                    onError={(e) => {
                      (e.target as HTMLImageElement).src =
                        "path/to/default/image.png";
                    }}
                  />
                </div>
                {/* Timestamp and Address */}
                {timeStampLocationJson && (
                  <>
                    {timeStampLocationJson?.locations?.map((location: any) => {
                      if (location.userID === formJson?.teamMember2?.userID) {
                        const timestamp =
                          timeStampLocationJson?.timeStamps?.find(
                            (time: any) => time.userID === location.userID
                          );
                        return (
                          <div key={location.userID} className="tw-mt-2">
                            <p className="tw-text-sm tw-text-gray-600">
                              <span className="tw-font-semibold">
                                Location:
                              </span>{" "}
                              {location.address}
                            </p>
                            <p className="tw-text-sm tw-text-gray-600">
                              <span className="tw-font-semibold">
                                Timestamp:
                              </span>{" "}
                              {timestamp?.timestamp}
                            </p>
                          </div>
                        );
                      }
                      return null;
                    })}
                  </>
                )}
              </div>
            )}

            {/* Additional Team Members */}
            {formJson?.additionalTeamMembers?.map(
              (member: any, index: number) => {
                const locationData = timeStampLocationJson?.locations?.find(
                  (loc: any) => loc.userID === member.userID
                );
                const timestampData = timeStampLocationJson?.timeStamps?.find(
                  (time: any) => time.userID === member.userID
                );

                return (
                  <div
                    key={member.userID}
                    className="tw-flex tw-items-start tw-justify-start tw-gap-2 tw-flex-col"
                  >
                    <div className="tw-flex tw-items-center tw-gap-1 tw-flex-wrap">
                      <p className="leak-detail-label">
                        Additional Team Member {index + 1}:
                      </p>
                      <p className="leak-value">{member.displayName}</p>
                    </div>
                    <p className="leak-detail-label">
                      Photo of additional team member {index + 1}
                    </p>
                    <div className="tw-flex tw-gap-2 tw-items-start tw-justify-start tw-flex-wrap">
                      <Image
                        src={getPhotoUrl(member.userID)}
                        alt="team member"
                        className="tw-w-32 tw-shrink-0 tw-object-contain"
                        indicatorIcon={icon}
                        preview
                        loading="lazy"
                        pt={{
                          rotateRightButton: { className: "tw-text-white" },
                          downloadButton: { className: "tw-text-white" },
                          rotateLeftButton: { className: "tw-text-white" },
                          zoomInButton: { className: "tw-text-white" },
                          zoomOutButton: { className: "tw-text-white" },
                          closeButton: { className: "tw-text-white" },
                        }}
                        onError={(e) => {
                          (e.target as HTMLImageElement).src =
                            "path/to/default/image.png";
                        }}
                      />
                    </div>
                    {/* Timestamp and Address */}
                    {locationData && timestampData && (
                      <div className="tw-flex tw-flex-col tw-gap-1 tw-mt-2">
                        <p className="tw-text-sm tw-text-gray-600">
                          <span className="tw-font-semibold">Location:</span>{" "}
                          {locationData.address}
                        </p>
                        <p className="tw-text-sm tw-text-gray-600">
                          <span className="tw-font-semibold">Timestamp:</span>{" "}
                          {timestampData.timestamp}
                        </p>
                      </div>
                    )}
                  </div>
                );
              }
            )}
          </div>
          <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 2xl:tw-grid-cols-4 tw-gap-6 tw-px-4 tw-p-4">
            <div className="tw-flex tw-flex-col tw-items-start tw-gap-1 xl:tw-col-span-2">
              <p className="leak-detail-label">
                Photo of Van at the Start of the Day (Photo 1){" "}
              </p>
              <Image
                src={getVanPhoto(1)}
                alt="team member"
                className="tw-w-32 tw-shrink-0 tw-object-contain"
                indicatorIcon={icon}
                preview
                loading="lazy"
                pt={{
                  rotateRightButton: { className: "tw-text-white" },
                  downloadButton: { className: "tw-text-white" },
                  rotateLeftButton: { className: "tw-text-white" },
                  zoomInButton: { className: "tw-text-white" },
                  zoomOutButton: { className: "tw-text-white" },
                  closeButton: { className: "tw-text-white" },
                }}
                onError={(e) => {
                  (e.target as HTMLImageElement).src =
                    "path/to/default/image.png";
                }}
              />
            </div>
            <div className="tw-flex tw-flex-col tw-items-start tw-gap-1 xl:tw-col-span-2">
              <p className="leak-detail-label">
                Photo of Van at the Start of the Day (Photo 2){" "}
              </p>
              <Image
                src={getVanPhoto(2)}
                alt="team member"
                className="tw-w-32 tw-shrink-0 tw-object-contain"
                indicatorIcon={icon}
                preview
                loading="lazy"
                pt={{
                  rotateRightButton: { className: "tw-text-white" },
                  downloadButton: { className: "tw-text-white" },
                  rotateLeftButton: { className: "tw-text-white" },
                  zoomInButton: { className: "tw-text-white" },
                  zoomOutButton: { className: "tw-text-white" },
                  closeButton: { className: "tw-text-white" },
                }}
                onError={(e) => {
                  (e.target as HTMLImageElement).src =
                    "path/to/default/image.png";
                }}
              />
            </div>
          </div>
          <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-6 tw-px-4 tw-p-4">
            <div className="tw-flex tw-flex-col tw-items-start tw-gap-1 ">
              <p className="leak-detail-label">Key Plant Details </p>
              <p className="leak-value">
                {formJson?.keyPlantDetails?.map(
                  (keyPlant: any, index: number) => (
                    <span key={index}>
                      {keyPlant.name}
                      {index + 1 < formJson?.keyPlantDetails.length ? ", " : ""}
                    </span>
                  )
                )}
              </p>
            </div>
            <div className="tw-flex tw-flex-col tw-items-start tw-gap-1 ">
              <p className="leak-detail-label">Activity </p>
              <p className="leak-value">
                {formJson?.activity?.map((activity: any, index: number) => (
                  <span key={index}>
                    {activity.name}
                    {index + 1 < formJson?.activity.length ? ", " : ""}
                  </span>
                ))}
              </p>
            </div>
          </div>
        </div>
        <div className="tw-pt-4 tw-pb-2 tw-border-b-[1px] tw-border-[#E2E8F0] tw-px-4 ">
          <h2 className="tw-text-xl tw-font-semibold tw-text-[#101828]">
            Part 2: Emergency Details
          </h2>
        </div>
        <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 2xl:tw-grid-cols-4 tw-gap-6 tw-px-4 tw-py-4">
          <div className="tw-flex tw-flex-col tw-items-start tw-gap-1">
            <p className="leak-detail-label">Closest A&E </p>
            <p className="leak-value">
              {" "}
              {formJson?.emergencyDetails?.aAndE || "N/A"}
            </p>
          </div>
          <div className="tw-flex tw-flex-col tw-items-start tw-gap-1">
            <p className="leak-detail-label">Others </p>
            <p className="leak-value">
              {" "}
              {formJson?.emergencyDetails?.others || "N/A"}
            </p>
          </div>
          <div className="tw-flex tw-flex-col tw-items-start tw-gap-1">
            <p className="leak-detail-label">Details of Emergency Contact </p>
            <p className="leak-value">
              {formJson?.emergencyDetails?.emergencyContact}
            </p>
          </div>
          <div className="tw-flex tw-flex-col tw-items-start tw-gap-1">
            <p className="leak-detail-label">
              Is a First Aider available on site{" "}
            </p>
            <p className="leak-value">
              {" "}
              {formJson?.emergencyDetails?.isFirstAiderAvailable ? "Yes" : "No"}
            </p>
          </div>
          <div className="tw-flex tw-flex-col tw-items-start tw-gap-1">
            <p className="leak-detail-label">
              Is a first aid kit available on site{" "}
            </p>
            <p className="leak-value">
              {formJson?.emergencyDetails?.isFirstAidKitAvailable
                ? "Yes"
                : "No"}
            </p>
          </div>
        </div>
        <div className="tw-pt-4 tw-pb-2 tw-border-b-[1px] tw-border-[#E2E8F0]  tw-px-4">
          <h2 className="tw-text-xl tw-font-semibold tw-text-[#101828]">
            Part 3: Risk Assessment and Controls
          </h2>
        </div>
        <div>
          <DataTable
            value={formJson?.startWorkAssessment?.checklist || []}
            className="tw-p-4"
            emptyMessage="No risk assessments found."
            showGridlines
          >
            <Column field="label" header="3.1 Start Work Assessment " />
            <Column
              header="Action"
              body={(rowData) => {
                const showButton =
                  rowData.value === true &&
                  [
                    "preUseInspection",
                    "confinedSpaceEntryTraining",
                    "confinedSpaceEntryPermit",
                  ].includes(rowData.name);

                return (
                  <div className="tw-flex tw-items-center tw-gap-2">
                    {rowData.value === true ? (
                      <span>Yes</span>
                    ) : rowData.value === false ? (
                      <span>No</span>
                    ) : (
                      <span>N/A</span>
                    )}
                    {showButton && (
                      <Button
                        label={`View Form`}
                        onClick={() => {
                          if (rowData.name === "preUseInspection") {
                            setShowEquipmentFormPopup(true);
                          } else if (
                            rowData.name === "confinedSpaceEntryTraining"
                          ) {
                            setShowConfinedSpaceFormPopup(true);
                          } else if (
                            rowData.name === "confinedSpaceEntryPermit"
                          ) {
                            setShowPermitSpaceFormPopup(true);
                          }
                        }}
                        // disabled={invoiceDetailsLoading}
                        className={` tw-border-gray-300 tw-text-blue-500tw-border-gray-700 tw-border tw-border-solid  tw-w-fit tw-px-2 tw-py-1 tw-text-sm tw-font-semibold focus:tw-shadow-none tw-mt-2`}
                        // className="tw-text-blue-500 tw-text-sm tw-font-semibold"
                        text
                      />
                    )}
                  </div>
                );
              }}
            />
          </DataTable>
          <DataTable
            value={formJson?.startWorkAssessment?.riskelements || []}
            className="tw-p-4"
            emptyMessage="No risk assessments found."
            showGridlines
          >
            <Column field="label" header="3.2 Risk Elements " />
            <Column
              field="Ans"
              header="Value"
              style={{ width: "100px" }}
              body={(rowData) => (
                <span
                // className={`tw-text-sm tw-font-bold
                //   ${
                //   rowData.value === true
                //     ? "tw-text-green-600"
                //     : "tw-text-red-600"
                // }
                //     `}
                >
                  {rowData.value === undefined || rowData.value === null
                    ? "-"
                    : rowData.value === true
                    ? "Yes"
                    : "No"}
                </span>
              )}
            />
            <Column
              field="actions"
              header="Actions"
              style={{ maxWidth: "200px" }}
              body={(rowData) => (
                <ul className="tw-list-disc tw-pl-4">
                  {rowData.action && rowData.value === true
                    ? rowData.action.map((action: any, index: any) => (
                        <li key={index} className="tw-text-sm tw-text-gray-700">
                          {action.name}
                        </li>
                      ))
                    : "-"}
                </ul>
              )}
            />
          </DataTable>
        </div>
        {/* Signatures Section */}
        <div className="xl:tw-grid tw-grid-cols-3 tw-flex tw-justify-start tw-items-start tw-flex-wrap xl:tw-gap-5 tw-gap-3   tw-mt-4 tw-w-full lg:tw-w-fit tw-p-4">
          {/* Team Member 1 Signature */}
          <div className="tw-flex tw-flex-col tw-items-start tw-w-full sm:tw-w-[270px]  lg:tw-w-fit xl:tw-max-w-[380px]">
            <div className="tw-flex tw-items-center tw-gap-2 tw-justify-between tw-w-full">
              <p className="leak-detail-label tw-text-black tw-max-w-[60%] tw-truncate">
                {formJson?.teamMember1?.displayName || "Unknown User"}
              </p>
              <p className="tw-text-sm">{formatDate(formData.formDate)}</p>
            </div>
            <div className="tw-flex tw-flex-col tw-items-end tw-w-full tw-justify-end">
              <div className="tw-border tw-rounded xl:tw-w-[370px]  tw-w-full tw-bg-gray-100 ">
                {getSignatureUrl(formJson.teamMember1.userID) ? (
                  <img
                    src={getSignatureUrl(formJson.teamMember1.userID)}
                    alt="signature"
                    className="tw-h-32 tw-object-contain"
                  />
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>

          {/* Team Member 2 Signature */}
          {formJson?.teamMember2?.userID && (
            <div className="tw-flex tw-flex-col tw-items-start tw-w-full sm:tw-w-[270px]  lg:tw-w-fit xl:tw-max-w-[380px]">
              <div className="tw-flex tw-items-center tw-gap-2 tw-justify-between tw-w-full">
                <p className="leak-detail-label tw-text-black tw-max-w-[60%] tw-truncate">
                  {formJson?.teamMember2?.displayName || "Unknown User"}
                </p>
                <p className="tw-text-sm">{formatDate(formData.formDate)}</p>
              </div>
              <div className="tw-flex tw-flex-col tw-items-end tw-w-full tw-justify-end">
                <div className="tw-border tw-rounded xl:tw-w-[370px]  tw-w-full tw-bg-gray-100 ">
                  {getSignatureUrl(formJson.teamMember2.userID) ? (
                    <img
                      src={getSignatureUrl(formJson.teamMember2.userID)}
                      alt="signature"
                      className=" tw-h-32  tw-object-contain"
                    />
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* Additional Team Members Signatures */}
          {formJson.additionalTeamMembers?.map((member: any, index: number) => (
            <div
              key={member.userID}
              className="tw-flex tw-flex-col tw-items-start tw-w-full sm:tw-w-[270px]  lg:tw-w-fit xl:tw-max-w-[380px]"
            >
              <div className="tw-flex tw-items-center tw-gap-2 tw-justify-between tw-w-full">
                <p className="leak-detail-label tw-text-black tw-max-w-[60%] tw-truncate">
                  {member?.displayName || "Unknown User"}
                </p>
                <p className="tw-text-sm">{formatDate(formData.formDate)}</p>
              </div>
              <div className="tw-flex tw-flex-col tw-items-end tw-w-full tw-justify-end">
                <div className="tw-border tw-rounded xl:tw-w-[370px]  tw-w-full tw-bg-gray-100 ">
                  {getSignatureUrl(member.userID) ? (
                    <img
                      src={getSignatureUrl(member.userID)}
                      alt="signature"
                      className=" tw-h-32  tw-object-contain"
                    />
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="tw-flex tw-justify-end tw-items-center tw-p-4  tw-gap-2 !tw-border-t-[#E2E8F0] tw-border-t-[1px]">
          <Button
            className="tw-flex tw-px-3 tw-py-2 tw-rounded tw-border-solid tw-border focus:tw-shadow-none  !tw-border-[#344054] tw-text-[#344054] tw-font-medium"
            label="Cancel"
            onClick={() =>
              navigate("/layout/health-and-safety/environment-surveying")
            }
            color="white"
          />
        </div>
      </div>
      {/* Equipment Form Popup */}
      <Dialog
        header="Equipment Pre-Use Inspection Form"
        visible={showEquipmentFormPopup}
        onHide={() => setShowEquipmentFormPopup(false)}
        modal
        className="tw-w-[90vw] tw-max-w-4xl"
        draggable={false}
        resizable={true}
      >
        <ViewEquipmentform
          attachedFormData={formData?.preUseEquipmentCheckListForm}
        />
      </Dialog>

      {/* Confined Space Form Popup */}
      <Dialog
        header="Confined Space Form"
        visible={showConfinedSpaceFormPopup}
        onHide={() => setShowConfinedSpaceFormPopup(false)}
        modal
        className="tw-w-[90vw] tw-max-w-4xl"
        draggable={false}
        resizable={true}
      >
        <ViewConfinedSpacesEquipment
          attachedFormData={formData?.preUseConfinedSpaceEquipmentForm}
        />
      </Dialog>

      {/* Permit Space Form Popup */}
      <Dialog
        header="Permit for Confined Space Entry"
        visible={showPermitSpaceFormPopup}
        onHide={() => setShowPermitSpaceFormPopup(false)}
        modal
        className="tw-w-[90vw] tw-max-w-4xl"
        draggable={false}
        resizable={true}
      >
        <ViewPermitSpaceEntryForm
          attachedFormData={formData?.permitConfinedSpaceEntryForm}
        />
      </Dialog>
    </React.Fragment>
  );
};

export default ViewEnvironmentalSurveying;
